import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.inquiryDraft.supplementDetails;
export const supplementDetailsSelector = (state: RootState) => getState(state).data;
export const supplementDetailsIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const supplementDetailsErrorSelector = (state: RootState) => getState(state).error;
